import { createTheme, Theme, ThemeOptions } from '@mui/material/styles';

import baseTheme from '../theme';
import { ValidClubCode } from '../../constants/mobileApp';
import mwgThemeOptions from './mwg';
import acaThemeOptions from './aca';
import acgThemeOptions from './acg';

const clubThemeOverrides: Record<ValidClubCode, ThemeOptions> = {
  '005': mwgThemeOptions,
  '212': acaThemeOptions,
  '006': acgThemeOptions,
};

export const getThemeForClub = (clubCode: string | null): Theme => {
  if (!clubCode || !(clubCode in clubThemeOverrides)) {
    return baseTheme;
  }

  return createTheme(baseTheme, clubThemeOverrides[clubCode as ValidClubCode]);
};

export default getThemeForClub;
